import {
  NOTE_DATE_CONTEXT_KEYS,
  type NoteEditorBlockDef,
  type NoteValueType,
} from '../config';

// Scribe's `NoteBlock.ValueType()`, which owns the rule; the parity test
// holds both to one table.
export const noteValueType = (
  block: Pick<NoteEditorBlockDef, 'Kind'>,
): NoteValueType | null => {
  switch (block.Kind.case) {
    case 'FreeText':
      return 'text';
    case 'Choice':
    case 'MultiChoice':
    case 'ListRef':
      return 'choice';
    case 'Teeth':
      return 'teeth';
    case 'Date':
      return 'date';
    case 'Number':
      return 'number';
    case 'Table':
      return 'table';
    case 'Context':
      return NOTE_DATE_CONTEXT_KEYS.includes(block.Kind.value.Key)
        ? 'date'
        : 'text';
    default:
      return null;
  }
};
